/** Клавиатура кода: общая для входа и для задания кода. */

const LETTERS: Record<string, string> = {
  '1': '',
  '2': 'абвг',
  '3': 'дежз',
  '4': 'ийкл',
  '5': 'мноп',
  '6': 'рсту',
  '7': 'фхцч',
  '8': 'шщъы',
  '9': 'ьэюя',
}

export default function Keypad({ onDigit, onErase, leftLabel, onLeft }: {
  onDigit: (d: string) => void
  onErase: () => void
  leftLabel: string
  onLeft: () => void
}) {
  return (
    <div className="m-pad">
      {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((d) => (
        <button key={d} className="m-key" onClick={() => onDigit(d)}>
          <span className="m-key-d">{d}</span>
          <span className="m-key-l">{LETTERS[d]}</span>
        </button>
      ))}

      <button className="m-key m-key-flat" onClick={onLeft}>
        {leftLabel}
      </button>

      <button className="m-key" onClick={() => onDigit('0')}>
        <span className="m-key-d">0</span>
        <span className="m-key-l" />
      </button>

      <button className="m-key m-key-flat" onClick={onErase} aria-label="Стереть">
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#9cc5dc" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 6H9l-5 6 5 6h11a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1Z" />
          <path d="m14 10-4 4M10 10l4 4" />
        </svg>
      </button>
    </div>
  )
}
